import SuspenseBoundary from './SuspenseBoundary'

export default SuspenseBoundary
